export const CSI_PROJECT_NAME = 'stender';
